module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic.d52b4271.woff2";